import { Component, HostBinding, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../_services/data.service';
import { TranslateService } from '@ngx-translate/core';
// import { slideRight } from 'src/app/animations';

@Component({
  selector: 'app-user-home',
  templateUrl: './user-home.component.html',
  styleUrls: ['./user-home.component.scss'],
  host: {
    '[class.not-active-menu]': '!projPassToParentShowMenu'
  }
})
export class UserHomeComponent implements OnInit {

  projPassToParentShowMenu: boolean = true;
  spirikalCopyright: boolean = true;
  // compositeDesign: boolean = false;
  // getKey1CompaniesId: any[] = ['f1YjmQYrERNEUiq1fsVL', 'rEvne4tx1cx89sWZePVf'];
  // skatorzaCompaniesId: any[] = ['M340PKgS3CG0PR1ZowYk', '4Ski1N8LeBkbe9lk37lk'];
  // getKey1CompaniesId: any[] = [''];
  // skatorzaCompaniesId: any[] = [''];
  isMenu: boolean = true;
  sehelProjId: string = '';
  showAll: boolean = false;
  sehelUser: string = '';
  desktopResolution: boolean = false;
  stiky: boolean = false;
  mapPage: boolean = false;
  lang: 'he';
  writeDirection: string = 'rtl';
  langClass: string = '';
  company: any = {};





  constructor(private router: Router, public dataService: DataService, private route: ActivatedRoute, public translate: TranslateService) {
    router.events.forEach((event) => {

      const firstChild = this.route.snapshot.firstChild;

      if (firstChild && firstChild.url[1] && firstChild.url[1].path === 'n') {
        firstChild.url[1].path = 'u';
        const params = Object.values(firstChild.params).join('/');
        this.router.navigate(['company/u/'+ params]);
      }
      if (this.route.snapshot.firstChild.params.flatId) {
        this.pageClassFalse();
        this.isFlat = true;
      }
      else if (!this.route.snapshot.firstChild.params.flatId &&
        this.route.snapshot.firstChild.params.buid) {
        this.pageClassFalse();
        this.isBuilding = true;
      }
      else if (this.route.snapshot.firstChild.params.userId) {
        this.route.snapshot.firstChild.url.forEach(segment => {
          if(segment.path === 'calculator-offer'){
           this.isOffer = true;
          }
        })}
      else if (this.route.snapshot.firstChild.params.section) {
        this.pageClassFalse();
        this.isGal = true;
      }
      else if (this.route.snapshot.firstChild.params.viewFromFloor) {
        this.pageClassFalse();
        this.isFloor = true;
      }
      else if (this.route.snapshot.firstChild.url[this.route.snapshot.firstChild.url.length - 1].path === 'about') {
        this.pageClassFalse();
        this.isAboutProject = true;
      }
      else if (this.route.snapshot.firstChild.url[this.route.snapshot.firstChild.url.length - 1].path === 'nearbyProject') {
        this.pageClassFalse();
        this.isMap = true;
      }
      else if (!this.route.snapshot.firstChild.params.flatId &&
        !this.route.snapshot.firstChild.params.buid &&
        this.route.snapshot.firstChild.params.idp) {
        this.pageClassFalse();
        this.isProj = true;
      }
    });
  }

  pageClassFalse(){
    this.isGal = false;
    this.isProj = false;
    this.isBuilding = false;
    this.isFlat = false;
    this.isFloor = false;
    this.isMap = false;
    this.isAboutProject = false;
  }

  @HostBinding('class.composite-design') compositeDesign: boolean = false;
  @HostBinding('class.unika') unika: boolean = false;
  @HostBinding('class.isFlat') isFlat: boolean = false;
  @HostBinding('class.isBuilding') isBuilding: boolean = false;
  @HostBinding('class.isProj') isProj: boolean = false;
  @HostBinding('class.isGal') isGal: boolean = false;
  @HostBinding('class.isFloor') isFloor: boolean = false;
  @HostBinding('class.isMap') isMap: boolean = false;
  @HostBinding('class.isAboutProject') isAboutProject: boolean = false;
  @HostBinding('class.no-user-strip') showAdminButton: boolean = true;
  @HostBinding('class.hide-right-menu') hideRightMenu: boolean = false;
  @HostBinding('class.ios') isIOSDevice: boolean = false;
  @HostBinding('class.dark-theme') isDarkTheme: boolean = true;
  @HostBinding('class.habait') habait: boolean = false;
  @HostBinding('class.remove-menu') isOffer: boolean = false;
  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    if (scrollY > 50) {
      this.stiky = true;
    } else {
      this.stiky = false;
    }
  }

  ngOnInit() {
    // if(this.route.firstChild.snapshot.paramMap.get('idp')) {
    //   this.isMenu = true;
    // } else {
    //   this.isMenu = false;
    // }
    if (this.route.snapshot.queryParams.lang) {
      this.translate.use(this.route.snapshot.queryParams.lang);
      this.translateLocal(this.route.snapshot.queryParams.lang);
    }

    if(this.dataService.hoisUrl() === 'https://habaitproject.co.il'){
      this.habait = true;
    } else {
      this.habait = false;
    }
    this.isIOSDevice = this.detectIOS();
    // if (window.location.origin === 'https://spirical.net' || 'bs-localStorage.com:4200' || 'http://localhost:4200/') {
      if (window.location.origin === 'https://spirical.net') {
      this.showAdminButton = true;
    } else {
      this.showAdminButton = false;
    }
    if (window.innerWidth > 1200) {
      this.desktopResolution = true;
    } else {
      this.desktopResolution = false;
    }
    if(this.route.snapshot.firstChild.url[3]) {
      if(this.route.snapshot.firstChild.url[3].path === 'map'){
        this.mapPage = true;
      }
    }
    this.sehelProjId = this.route.snapshot.firstChild.params.sehelProjId;
    this.sehelUser = this.route.snapshot.firstChild.params.seheluser;
    if (this.sehelProjId) {
      console.log('this.sehelProjId', this.sehelProjId);
      this.dataService.getSpecProjectSehel(this.sehelProjId).subscribe(proj => {
        if (proj.length > 0) {
          let compId = proj[0].parrentId
          let projUid = proj[0].uid
          this.router.navigate(['/company/u/' + compId + '/' + projUid + '/seheluser/' + this.sehelUser])
          // .then(() => {
          //   window.location.reload();
          // });
          this.showAll = true;
        }
      });
    } else {
      this.showAll = true;
    }
    this.dataService.removeMenu.subscribe(isShow => {
      this.isMenu = isShow;
    });
    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;
    // if(!this.unika){
    //   this.isDarkTheme = false;
    // }
    console.log(window.location.host);
    // if (window.location.host === 'getkey1.online') {
    //   let ifGetKey1CompanieId = this.getKey1CompaniesId.filter(compId => {
    //     return this.route.firstChild.snapshot.params.id === compId
    //   });
    //   if (ifGetKey1CompanieId.length > 0) {
    //     this.spirikalCopyright = false;
    //   } else {
    //     this.router.navigate(['/page404']);
    //   }
    // }
    // if (window.location.host === 's-katorza.com') {
    //   let ifskatorzaCompaniesId = this.skatorzaCompaniesId.filter(compId => {
    //     return this.route.firstChild.snapshot.params.id === compId
    //   });
    //   if (ifskatorzaCompaniesId.length > 0) {
    //     this.spirikalCopyright = false;
    //   } else {
    //     this.router.navigate(['/page404']);
    //   }
    // }
    // this.route.firstChild.url.subscribe(segment => {
    //   segment.values;
    // for (let i = 0; segment.length > i; i++) {
    //   if (segment[i].path === 'n') {
    //     this.compositeDesign = true;
    //   } else if (segment[i].path === 'u') {
    //     this.compositeDesign = true;
    //     this.unika = true;
    //   }
    // }
    // })
  }

  translateLocal(curLang) {
    this.translate.use(curLang);
    this.updateLanguage(curLang);
  }
  updateLanguage(curLang?): void {
    if (curLang.length > 0) {
      this.company.lang = curLang;
    }
    if (this.company.lang) {
      this.lang = this.company.lang;
      if (this.company.lang === 'en') {
        this.translate.use('en');
        this.writeDirection = "ltr";
        this.langClass = "ltr-lang";
      } else if (this.lang === "he" || this.lang === "ar") {
        this.writeDirection = "rtl"
        this.langClass = ""
      } else {
        this.lang = "he";
      }
    }
    this.translate.use(curLang);
    document.documentElement.lang = this.lang;
    document.documentElement.dir = this.writeDirection;
    document.documentElement.classList.value = this.langClass;
  }

  detectIOS() {

    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    var isAppleDevice = navigator.userAgent.includes('Macintosh');

    var isTouchScreen = navigator.maxTouchPoints >= 1; // true for iOS 13 (and hopefully beyond)

    return isIOS || (isAppleDevice && (isTouchScreen || this.iOS1to12quirk()));

  }

  iOS1to12quirk() {

    var audio = new Audio(); // temporary Audio object

    audio.volume = 0.5; // has no effect on iOS <= 12

    return audio.volume === 1;

  };

 

  projPassToParentShowMenuF(event) {
    this.projPassToParentShowMenu = event;
    if (this.route.snapshot.queryParams.m === 'all') {
      this.projPassToParentShowMenu = false;
    } else if (this.route.snapshot.queryParams.m === 'n') {
      this.hideRightMenu = true;
    }
    if(this.route.snapshot.firstChild.url[3]) {
      if(this.route.snapshot.firstChild.url[3].path === 'map'){
        this.mapPage = true;
      } else {
        this.mapPage = false;
      }
    } else {
      this.hideRightMenu = true;
    }
  }
}
